// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/audit_search.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { TaskView } from "./task";
import { TaskAuditView } from "./audit";
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditSearchServiceSearchRequest
 */
export interface TaskAuditSearchServiceSearchRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * The list of user IDs who are involved in the audit events.
     *
     * @generated from protobuf field: repeated string user_ids = 3;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditWithTask
 */
export interface TaskAuditWithTask {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskAuditView audit = 1;
     */
    audit?: TaskAuditView;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskView task = 2;
     */
    task?: TaskView;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskAuditSearchServiceSearchResponse
 */
export interface TaskAuditSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskAuditWithTask list = 1;
     */
    list: TaskAuditWithTask[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditSearchServiceSearchRequest$Type extends MessageType<TaskAuditSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.task.v1.TaskAuditSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditSearchServiceSearchRequest
 */
export const TaskAuditSearchServiceSearchRequest = new TaskAuditSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditWithTask$Type extends MessageType<TaskAuditWithTask> {
    constructor() {
        super("c1.api.task.v1.TaskAuditWithTask", [
            { no: 1, name: "audit", kind: "message", T: () => TaskAuditView },
            { no: 2, name: "task", kind: "message", T: () => TaskView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditWithTask
 */
export const TaskAuditWithTask = new TaskAuditWithTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditSearchServiceSearchResponse$Type extends MessageType<TaskAuditSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.task.v1.TaskAuditSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskAuditWithTask },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskAuditSearchServiceSearchResponse
 */
export const TaskAuditSearchServiceSearchResponse = new TaskAuditSearchServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.task.v1.TaskAuditSearchService
 */
export const TaskAuditSearchService = new ServiceType("c1.api.task.v1.TaskAuditSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: TaskAuditSearchServiceSearchRequest, O: TaskAuditSearchServiceSearchResponse }
]);
